export default {
    name: "copy-text",
    el: null,
    init() {
        this.el = document.querySelector("#js_copy_to_clipboard");

        if (!this.el) return;

        this.el.addEventListener('click', this.copy.bind(this));
    },

    copy() {

        var dummy = document.createElement("textarea");
        document.body.appendChild(dummy);
        dummy.value = this.el.getAttribute('data-url');
        dummy.select();
        document.execCommand("copy");
        document.body.removeChild(dummy);

        this.el.style.position = "relative";

        const div = document.createElement("div");
        div.innerText = "Lenke kopiert til utklippstavle.";
        div.style.position = "absolute";
        div.style.right = "-150px";
        div.style.bottom = "-100px";
        div.style.padding = "1rem 1rem"
        div.style.background ="white";
        div.style.border = "1px solid #c0c0c0";
        div.style.borderRadius ="5px";
        div.style.boxShadow = "rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px";
        div.style.width = "200px";
        this.el.appendChild(div);

        setTimeout(() => {
            div.remove();
        }, 2000);
    },
};
